module.exports = __webpack_public_path__ + "static/media/dd_top_nav.6255e5d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dd_top_nav.jpg
// module id = 357
// module chunks = 0